module.exports = __webpack_public_path__ + "img/appMobileLanding.6c83c810.jpg";